/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './BackInStockDataService.g';

// @ts-ignore
function vSIGetAPIResponseQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('VSIGetRestAPIResponse', 'VSIRestAPIHandler', DataServiceEntities.VSIRestAPIHandlerExtensionClass, key);
}

export function createVSIInitiateRestCallInput(
    customerId: string,
    customerEmailAddress: string,
    productCode: string,
    company: string,
    quantity: string,
    emailSent: boolean,
    productCodeRefRecId: number
): IDataServiceRequest {
    const query = vSIGetAPIResponseQuery();
    return query.createDataServiceRequestForOperation(
        'VSI_AddPorductInterest',
        true,
        DataServiceEntities.VSIRestAPIHandlerExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IVSIRestAPIHandler' },
        { customerId, customerEmailAddress, productCode, company, quantity, emailSent, productCodeRefRecId }
    );
}

export function vSIInitiateRestCallAsync(
    context: IContext,
    customerId: string,
    customerEmailAddress: string,
    productCode: string,
    company: string,
    quantity: string,
    emailSent: boolean,
    productCodeRefRecId: number
): AsyncResult<DataServiceEntities.IVSIRestAPIHandler> {
    const request = createVSIInitiateRestCallInput(
        customerId,
        customerEmailAddress,
        productCode,
        company,
        quantity,
        emailSent,
        productCodeRefRecId
    );
    return callActionOrExecute<DataServiceEntities.IVSIRestAPIHandler>(request, context.callerContext);
}
